// extracted by css-extract-rspack-plugin
export default {"refreshLink":"hjFm9"};